import { Stack, Typography } from "@mui/material";
import { skipToken } from "@reduxjs/toolkit/query";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useGetMessageThreadByProductSlugQuery } from "src/api/services/messagesApi";
import { MatchParam } from "src/constants/matches";
import { Paths } from "src/constants/paths";
import CancellationFooter from "../CancellationFooter";
import { useUpdateVisit } from "src/hooks/useUpdateVisit";

const message = [
  "cancellationMessage.text.0",
  "cancellationMessage.text.1",
  "cancellationMessage.text.2",
  "cancellationMessage.text.3",
];

const Message = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const page = "cancellationMessage";
  const { product } = useParams<MatchParam<"PRODUCT_NAME">>();
  const { data: thread } = useGetMessageThreadByProductSlugQuery(
    product ?? skipToken
  );
  const updateVisit = useUpdateVisit();

  const handleGoToMessage = useCallback(() => {
    if (thread == null) return null;

    updateVisit({
      canceled_at: new Date().toISOString(),
      status: "canceled",
    });

    return navigate(`${Paths.MESSAGING}/${thread.slug}`);
  }, [navigate, thread, updateVisit]);

  return (
    <Stack gap={4}>
      <Stack gap={2}>
        {message.map((m, idx) => (
          <Typography key={idx}>{t(`${m}`)}</Typography>
        ))}
      </Stack>
      <CancellationFooter
        refuseText={t(`${page}.button.message`, "Message my provider")}
        continueText={t(`${page}.button.continue`, "I understand, continue")}
        question={`0KInpCyg`}
        onRefuse={handleGoToMessage}
      />
    </Stack>
  );
};

export default Message;
